import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/v1/admin/dashboard`;

export default {
  summary(payload) {
    return Client.post(resource, {}, {
      headers: {
        action: "summary",
      },
    });
  },
};
